import React from 'react'
import i18next from 'i18next'
import { useTranslation } from 'react-i18next'
import MinimumQuantity from '../../../components/minimum-quantity/MinimumQuantity'
import QuantityInput from '../../../components/quantity-input/QuantityInput'
import { productMeta, productName } from '../../../components/menu-item/MenuItem'
import { isBelowMinimum } from '../../../utils/minimumQuantity'
import { IProduct } from '../../../types/products'
import { imageUrl } from '../../../utils/imageUrl'
import { setCartQuantity } from '../../../utils/cart'
import { handleImageFallback } from '../../../utils/brand'
import { useAppType } from '../../../context/AppContext'
import { useOpenProduct } from '../../../utils/openProduct'
import './CartPageItem.scss'

type Props = {
  data: IProduct
  setCart: React.Dispatch<React.SetStateAction<IProduct[]>>
  index?: number
}
const c = 'cart-page-item'

const CartPageItem = ({ data, setCart, index = 0 }: Props) => {
  const { t } = useTranslation()
  const openProduct = useOpenProduct()
  const appType = useAppType()
  const quantity = data?.quantity ?? 1
  const description =
    i18next.language === 'ru' && data?.ru_description
      ? data.ru_description
      : data?.description
  const summary = (description ?? '')
    .split('_')
    .map((line) => line.trim())
    .filter(Boolean)
    .join(', ')

  const setQuantity = (next: number | ((prev: number) => number)) => {
    const value = typeof next === 'function' ? next(quantity) : next
    setCart((prev) => setCartQuantity(prev, data._id, value))
  }

  return (
    <div
      className={`${c}${isBelowMinimum(data) ? ' minimum-quantity-invalid' : ''}`}
      style={{ animationDelay: `${Math.min(index, 6) * 60}ms` }}
    >
      <button
        className={`${c}__image`}
        onClick={(e) => openProduct(data._id, e.currentTarget)}
        aria-label={productName(data)}
      >
        <img
          src={imageUrl(data?.image, 240)}
          alt=''
          loading='lazy'
          decoding='async'
          onError={handleImageFallback(appType)}
        />
        {data?.discount && <span className={`${c}__sale`}>-{data.discount}%</span>}
      </button>
      <div className={`${c}__body`}>
        <div className={`${c}__title`}>{productName(data)}</div>
        {data?.selectedIngredients && data.selectedIngredients.length > 0 && (
          <div className={`${c}__ingredients`}>
            {data.selectedIngredients.map((ing) => (
              <span key={ing._id}>
                +{i18next.language === 'ru' && ing.label_ru ? ing.label_ru : ing.label}
              </span>
            ))}
          </div>
        )}
        {summary && <div className={`${c}__description`}>{summary}</div>}
        <div className={`${c}__meta`}>
          {[productMeta(data, t('PIECES')), `${data.price} lei`]
            .filter(Boolean)
            .join(' · ')}
        </div>
        {isBelowMinimum(data) && <MinimumQuantity product={data} invalid />}
        <div className={`${c}__footer`}>
          <QuantityInput quantity={quantity} setQuantity={setQuantity} cartItem size='sm' />
          <div className={`${c}__total`}>
            <span key={quantity}>{Number(data?.price) * quantity}</span> lei
          </div>
        </div>
      </div>
    </div>
  )
}

export default CartPageItem
